module.exports = __webpack_public_path__ + "static/media/rebook.9d0e2f33.jpg";